'use client';

import { useSprdConsentListener } from '@/atoms/sprdConsentAtom';

// Keeps the sprdConsent atom in sync with the cookie banner. Consumers (Zendesk chat, Raygun
// crash reporting) read it via useSprdConsent.
export const ConsentCallback = () => {
  useSprdConsentListener();

  return null;
};
